// tslint:disable:no-use-before-declare
import {
  Directive,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  forwardRef,
  Provider
} from '@angular/core';
import { 
  ControlValueAccessor, 
  NG_VALUE_ACCESSOR } from '@angular/forms';

// Class to apply to the checked buttons
export const PmdCheckboxControlValueAccessor: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => PmdButtonCheckbox),
  multi: true
};

/**
 * Add checkbox functionality to any element
 */
@Directive({
  selector: '[pmdBtnCheckbox], [pmdBtnToggle]',
  providers: [PmdCheckboxControlValueAccessor]
})

export class PmdButtonCheckbox implements ControlValueAccessor, OnInit {

  /** Truthy value, will be set to ngModel */
  @Input() pmdBtnCheckboxTrue = true;

  /** Falsy value, will be set to ngModel */
  @Input() pmdBtnCheckboxFalse = false;

  @HostBinding('class.active')
  @HostBinding('attr.aria-pressed')
  state = false;

  protected value: boolean | string;
  protected isDisabled: boolean;

  protected onChange: any = Function.prototype;
  protected onTouched: any = Function.prototype;

  @HostListener('click')
  onClick(): void {
    if (this.isDisabled) {
      return;
    }

    this.toggle(!this.state);
    this.onChange(this.value);
  }

  ngOnInit(): void {
    this.toggle(this.trueValue === this.value);
  }

  protected get trueValue(): boolean {
    return typeof this.pmdBtnCheckboxTrue !== 'undefined'
      ? this.pmdBtnCheckboxTrue
      : true;
  }

  protected get falseValue(): boolean {
    return typeof this.pmdBtnCheckboxFalse !== 'undefined'
      ? this.pmdBtnCheckboxFalse
      : false;
  }

  toggle(state: boolean): void {
    this.state = state;
    this.value = this.state ? this.trueValue : this.falseValue;
  }

  writeValue(value: boolean | string | null): void {
    this.state = this.trueValue === value;
    this.value = value ? this.trueValue : this.falseValue;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  registerOnChange(fn: () => {}): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }
}
